module.exports = __webpack_public_path__ + "img/languan.6370ecd1.png";